import React, { Component } from 'react';
import { withRouter } from 'react-router';
import LoadingIndicator from '../LoadingIndicator';
import { PROPEL_URL_KEY } from '../../constants/constants';

import GlobalProps from './../../GlobalProps/GlobalProps';
import { AppContext } from '../../AppProvider';

export class Callback extends Component {
  async componentDidMount() {
    try {
      await this.props.auth.handleAuthentication();
      // once authenticated look for the URL we saved away with their original path and route them there.
      const globalProps = await this.loadGlobalProps();

      this.context.updateGlobalProps(globalProps);
      const url = localStorage.getItem(PROPEL_URL_KEY);
      if (globalProps.isPropelAdministrator) {
        this.props.history.push('/admin/organizations');
      } else if (url && url !== '/') {
        this.props.history.push(url);
        localStorage.removeItem(PROPEL_URL_KEY);
      } else {
        this.props.history.push('/dashboard');
      }
    } catch (err) {
      this.props.history.push('/loginerror');
    }
  }
  loadGlobalProps = async () => {
    const GP = new GlobalProps();
    let globalProps;
    try {
      globalProps = await GP.getProps();
      return Promise.resolve(globalProps);
    } catch (err) {
      return Promise.reject(err);
    }
  };
  render() {
    return <LoadingIndicator />;
  }
}

export default withRouter(Callback);
Callback.contextType = AppContext;
